<template>
  <div class="senses">
    <b-container fluid="xxl">
      <b-row class="text-center">
        <b-col>
          <input
            class="px-2 py-1 w-100"
            id="search"
            type="text"
            size="sm"
            placeholder="Search senses"
            @keyup="getSearchResults()"
            autocomplete="off"
            v-model="query"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <ul v-if="senses.length" class="results-ul">
            <li v-for="sense in senses" :key="sense.id">
              <a href="#" @click="selectSense($event, sense)">{{ sense.display }}</a>
            </li>
          </ul>
          <span v-else class="opacity-60">
            <span v-if="query">No results</span>
            <span v-else>Start searching</span>
          </span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'SenseAutocomplete',
    props: ['exclude'],
    data() {
      this.$store.state.sense.senses = []
      return {
        query: '',
        timer: null
      }
    },
    mounted() {
      this.$store.state.sense.senses = []
    },
    computed: {
      ...mapState({
        senses: state => state.sense.senses
      }),
      clearQuery(){
        return this.query.replace(/\*/gi, '')
      }
    },
    methods: {
      selectSense(event, sense){
        event.preventDefault()
        this.$emit('select', sense)
        this.$store.state.sense.senses = []
        this.query = ''
      },
      getSearchResults(){
        clearTimeout(this.timer)
        // let that = this
        this.timer = setTimeout(() => {
          this.$store.dispatch('searchSenses', {
            query: this.query.toLowerCase(),
            exclude: (this.exclude ? this.exclude : [])
          })
        }, 400)
      }
    }
  }
</script>
